import React from 'react';
import {
  IconAllInclusiveMeal,
  IconBed,
  IconCoffee,
  IconFullBoardMeal,
  IconHalfBoardMeal,
} from '@/app/common/icons/libraryIcons';
import type { StarfishLibraryIcon } from '@/app/common/icons/libraryIcons';
import { useTranslation } from '@/app/components/translations/Translation';

type MealPlanIconProps = {
  mealPlanType: string;
  showLabel?: boolean;
} & React.HTMLAttributes<HTMLElement>;

// Starfish has one cut of each board, so the linear/solid pair the library offered collapses.
const mealPlanIcons: { [key: string]: StarfishLibraryIcon } = {
  default: IconCoffee,
  'vacation.common.mealplantype.onlybed': IconBed,
  'vacation.common.mealplantype.bedandbreakfast': IconCoffee,
  'vacation.common.mealplantype.halfboard': IconHalfBoardMeal,
  'vacation.common.mealplantype.fullboard': IconFullBoardMeal,
  'vacation.common.mealplantype.allinclusive': IconAllInclusiveMeal,
};

function MealPlanIcon(props: MealPlanIconProps) {
  const { t } = useTranslation();
  const { mealPlanType, showLabel = false, ...rest } = props;
  const MealPlanTypeIcon = mealPlanIcons[mealPlanType] || mealPlanIcons.default;

  return showLabel ? (
    <div
      {...rest}
      css={`
        display: flex;
        align-items: center;
        column-gap: 0.25rem;
      `}
    >
      <MealPlanTypeIcon />
      <span>{t(mealPlanType)}</span>
    </div>
  ) : (
    <MealPlanTypeIcon className={rest.className} style={rest.style} />
  );
}

export default MealPlanIcon;
